export default "__VITE_ASSET__By63Vz5i__"